<script lang="ts" setup>
const props = defineProps({
  data: Object
});
</script>

<template>
  <div class="card">
    <figure class="card__pic">
      <nuxt-link :to="props.data.link">
        <Nimg :src="props.data.image" />
      </nuxt-link>
    </figure>
    <div class="card__bottom">
      <nuxt-link :to="props.data.link" class="card__title">{{ props.data.title }}</nuxt-link>
      <div class="card__category" v-if="props.data.category">{{ props.data.category }}</div>
      <div class="card__date" v-if="props.data.date">{{ props.data.date }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  padding: toRem(24);
  background-color: $color-white-1;

  @include max-media(480) {
    padding: toRem(12) toRem(12) toRem(24);
  }

  &__pic {
    border-radius: toRem(6);
    margin-bottom: toRem(24);

    img {
      display: block;
      width: 100%;
    }
  }

  &__bottom {
    display: flex;
    flex-wrap: wrap;
  }

  &__title {
    display: block;
    width: 100%;
    margin-bottom: toRem(12);
    font-size: toRem(20);
    font-weight: 500;
    color: $blue2;
    line-height: 1.4;
    @include dot-many-line(2);
  }

  &__category {
    display: inline-block;
    margin-right: toRem(8);
    padding: toRem(2) toRem(12);
    border-radius: toRem(4);
    color: $color-white-1;
    font-size: toRem(12);
    font-weight: 400;
    background-color: $blue3;
  }

  &__date {
    padding: toRem(2) toRem(12);
    color: $blue3;
    font-size: toRem(12);
    font-weight: 400;
    border-radius: toRem(4);
    border: 1px solid $bg-2;
  }
}
</style>
